class OrchestrationErrorService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }
  
  getErrors(customerId, offset, limit) {
    const url = `${this.config.apiRoot}/orchestrationLogs/${customerId}/uiErrorMessages?offset=${offset}&limit=${limit}`;
    return this.httpDim.get(url, this.config);
  }
  
}
  
OrchestrationErrorService.$inject = ['httpDim', 'config'];
  
export default OrchestrationErrorService;
  


// WEBPACK FOOTER //
// ./app/common/orchestrationError/orchestrationError.service.js